// eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-imports-ts
import { h } from '@stencil/core';

const CopyIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" class="" viewBox="0 0 32 32">
        <path
            d="M16 6H6.66667C6.29848 6 6 6.29848 6 6.66667V20C6 20.3682 6.29848 20.6667 6.66667 20.6667H12V22.6667H6.66667C5.19391 22.6667 4 21.4728 4 20V6.66667C4 5.19391 5.19391 4 6.66667 4H16C17.4728 4 18.6667 5.19391 18.6667 6.66667V8H16.6667V6.66667C16.6667 6.29848 16.3682 6 16 6Z"
            fill="#1D1D25"
        ></path>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.3333 12C13.3333 10.5272 14.5272 9.33333 16 9.33333H25.3333C26.8061 9.33333 28 10.5272 28 12V25.3333C28 26.8061 26.8061 28 25.3333 28H16C14.5272 28 13.3333 26.8061 13.3333 25.3333V12ZM16 11.3333H25.3333C25.7015 11.3333 26 11.6318 26 12V25.3333C26 25.7015 25.7015 26 25.3333 26H16C15.6318 26 15.3333 25.7015 15.3333 25.3333V12C15.3333 11.6318 15.6318 11.3333 16 11.3333Z"
            fill="#1D1D25"
        ></path>
    </svg>
);

export default CopyIcon;
